export interface ContactUsPageContent {
  hero: {
    header: string;
    subheader: string;
  };
  page: {
    intro: string;
  };
}

export const content: ContactUsPageContent = {
  hero: {
    header: "Contact Us",
    subheader: "Let’s discuss your IT / OT talent needs ...",
  },
  page: {
    intro:
      "Please send an email to: Support@cloud-talent.com or fill out the form below",
  },
};
